// material
import { Container, Stack } from '@mui/material';
import { Box } from '@mui/system';
// components
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
//

import PrintDownload from '../Global/PrintDownload';

// ----------------------------------------------------------------------

/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function PrintDownloadApplicationLeads() {
  return (
    <Page title="Partner Management System || Print & Download">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Print & Download" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <PrintDownload />
        </Box>
      </Container>
    </Page>
  );
}
